import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Button from "react-bootstrap/Button";
import { HiOutlineLightBulb } from "react-icons/hi";
import { FaCheck } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useState } from "react";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { AppRoute } from "../../router/routerConstants";
import AddSkillModal from "./common/add-skills-modal";
import {
  applyJob,
  uploadResume,
  uploadResumeList,
} from "../../service/apis/auth.api";
import { showError, showSuccess } from "../../utils/Common";
import { ButtonLoader } from "../../common/Loader/loader";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import {
  addResumeToList,
  clearResumeDetails,
  setResumeDetails,
  updateResume,
} from "../../store/resume.store";
import { LuPencilLine } from "react-icons/lu";

const ResumeAfteraddedQualificationInformationScreen = () => {
  const { resumeDetails,resumeList } = useSelector(
    (state: RootState) => state?.resumeSlice
  );
  const { user } = useSelector((state: RootState) => state.authSlice);
  const [showWork, setShowWork] = useState(false);
  const handleCloseWK = () => setShowWork(false);
  const handleShowWK = () => setShowWork(true);
  const [NavigateTo] = useCustomNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const nextHandler = async () => {
    if (resumeDetails) {
      try {
        setIsLoading(true);

        const response = await applyJob(resumeDetails);
        
        const updatedDetails = {
          resumeDetails: {
            name: response?.updateResume?.resumedata?.resume?.resumeData?.name,
            bio: response?.updateResume?.resumedata?.resume?.resumeData?.bio,
            email:
              response?.updateResume?.resumedata?.resume?.resumeData?.email,
            explevel:
              response?.updateResume?.resumedata?.resume?.resumeData?.explevel,
            contact:
              response?.updateResume?.resumedata?.resume?.resumeData?.contact,
            experiences:
              response?.updateResume?.resumedata?.resume?.resumeData
                ?.experiences,
            skills:
              response?.updateResume?.resumedata?.resume?.resumeData?.skills,
            achievements:
              response?.updateResume?.resumedata?.resume?.resumeData
                ?.achievements,
            educations:
              response?.updateResume?.resumedata?.resume?.resumeData
                ?.educations,

            resumeLink: response?.updateResume?.resumedata?.resume?.resumeLink,
            userId: response?.updateResume?.resumedata?.userId,
          },
        };

        if (user && user?.role === "jobseeker") {
          dispatch(setResumeDetails(updatedDetails?.resumeDetails));
        } else if (user && user?.role === "localagents") {
          dispatch(clearResumeDetails());
          
          if (resumeDetails?._id) {
          // Find the index of the resume to update
          const index = resumeList.findIndex(resume => resume._id === resumeDetails._id);

          if (index !== -1) {
            dispatch(updateResume({ index, data: updatedDetails.resumeDetails }));
              // console.log(index,resumeDetails._id,updatedDetails.resumeDetails,33);
          } else {
            // fallback: if not found, add it instead
            dispatch(addResumeToList(updatedDetails.resumeDetails));
          }


        } else {
          dispatch(addResumeToList(updatedDetails.resumeDetails));
        }
        }
        let payload = {
          ...updatedDetails.resumeDetails,
          jid: resumeDetails?.jobId,
        };

        let payloadForLocalAgent = {
          jid: resumeDetails?.jobId,
          candidates: [updatedDetails.resumeDetails],
        };
        if (resumeDetails?.jobId) {
          const uploadFunction =
            user?.role === "jobseeker"
              ? upload
              : user?.role === "localagents"
              ? uploadResumeByLocalAgent
              : null;

          if (uploadFunction) {
            const payloadToSend =
              user?.role === "jobseeker"
                ? payload
                : user?.role === "localagents"
                ? payloadForLocalAgent
                : null;
            await uploadFunction(payloadToSend);
          } else {
            showError("Invalid user role.");
          }
          // if (user && user?.role === "jobseeker") {
          //   await upload(payload);
          // } else if (user && user?.role == "localagents") {
          //   await uploadResumeByLocalAgent(payloadForLocalAgent);
          // }
        } else {
          if(response.status!=="error"){
            showSuccess(response?.message || "Resume generated successfully.");
            if (user && user?.role === "jobseeker") {
              NavigateTo(AppRoute.JOBSEEKER_JOBS_LISTING);
            } else if (user && user?.role === "localagents") {
              NavigateTo(AppRoute.AGENT_JOBS_LISTING);
            }
          }
        }
      } catch (err: any) {
        showError(err?.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const upload = async (payload?: any) => {
      payload = payload?.resumeLink ? { ...payload, resume: payload.resumeLink } : payload;

    await handleUpload(
      payload,
      uploadResume, // Use uploadResume API
      AppRoute.JOBSEEKER_JOBS_DETAILS,
      AppRoute.AGENT_JOBS_DETAILS
    );
  };

  const uploadResumeByLocalAgent = async (payload?: any) => {
    await handleUpload(
      payload,
      uploadResumeList, // Use uploadResumeList API
      AppRoute.JOBSEEKER_JOBS_DETAILS,
      AppRoute.AGENT_JOBS_DETAILS
    );
  };

  const handleUpload = async (
    payload: any,
    apiFunction: (payload: any) => Promise<any>, // API function to call
    jobseekerRoute: string,
    agentRoute: string
  ) => {
    try {      
      const response = await apiFunction(payload); // Dynamically call the passed API
      showSuccess(response?.message);
      const route = user?.role === "jobseeker" ? jobseekerRoute : agentRoute;
      NavigateTo(route, false, {
        jobId: resumeDetails?.jobId,
        status: response?.application?.status,
      });
    } catch (err: any) {
      showError(err?.message);
    }
  };

  // const upload = async (payload?: any) => {
  //   try {
  //     const response = await uploadResume(payload);
  //     showSuccess(response?.message);
  //     if (user && user?.role == "jobseeker") {
  //       NavigateTo(AppRoute.JOBSEEKER_JOBS_DETAILS, false, {
  //         jobId: resumeDetails?.jobId,
  //         status: response?.application?.status,
  //       });
  //     } else if (user && user?.role == "localagents") {
  //       NavigateTo(AppRoute.AGENT_JOBS_DETAILS, false, {
  //         jobId: resumeDetails?.jobId,
  //         status: response?.application?.status,
  //       });
  //     }
  //   } catch (err: any) {
  //     showError(err?.message);
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  // const uploadResumeByLocalAgent = async (payload?: any) => {
  //   try {
  //     const response = await uploadResumeList(payload);
  //     showSuccess(response?.message);
  //     if (user && user?.role == "jobseeker") {
  //       NavigateTo(AppRoute.JOBSEEKER_JOBS_DETAILS, false, {
  //         jobId: resumeDetails?.jobId,
  //         status: response?.application?.status,
  //       });
  //     } else if (user && user?.role == "localagents") {
  //       NavigateTo(AppRoute.AGENT_JOBS_DETAILS, false, {
  //         jobId: resumeDetails?.jobId,
  //         status: response?.application?.status,
  //       });
  //     }
  //   } catch (err: any) {
  //     showError(err?.message);
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  const prevHandler = () => {
    if (user && user?.role === "jobseeker") {
      if (
        resumeDetails?.achievements &&
        resumeDetails?.achievements?.length > 0
      )
        NavigateTo(AppRoute.JOBSEEKER_AFTER_ADDED_ACHIEVEMENTS);
      else NavigateTo(AppRoute.JOBSEEKER_ACHIEVEMENTS);
    } else if (user && user?.role === "localagents") {
      if (
        resumeDetails?.achievements &&
        resumeDetails?.achievements?.length > 0
      )
        NavigateTo(AppRoute.AGENT_AFTER_ADDED_ACHIEVEMENTS);
      else NavigateTo(AppRoute.AGENT_ACHIEVEMENTS);
    }
  };

  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && (
                  <AgentSidebarScreen />
                )}{" "}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && (
                  <AgentTopHeadScreen />
                )}{" "}
                <div className="profile-account-details-holder rightInnerScroll  common-padd-lt-rt ">
                  <div className="row">
                    <div className="col-lg-12 mb-4">
                      <div className="profile-account-details">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="title">
                              <h2>My Resume</h2>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="myResume-holder">
                              <div className="login-form-area add-password-form mt-5">
                                <div className="stepbar">
                                  <ul>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 1</p>
                                        <h4>About You</h4>
                                      </a>
                                    </li>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 2</p>
                                        <h4>Experience</h4>
                                      </a>
                                    </li>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 3</p>
                                        <h4>Education</h4>
                                      </a>
                                    </li>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 4</p>
                                        <h4>Achievements</h4>
                                      </a>
                                    </li>
                                    <li className="inprogress">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <HiOutlineLightBulb />
                                          </span>
                                        </div>
                                        <p>Step 5</p>
                                        <h4>Skills</h4>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className="comnbrdrGap profileEdit mb-4">
                                <div className="d-flex">
                                  <h3>My Qualification</h3>
                                  <button
                                    className="editbtn"
                                    onClick={handleShowWK}
                                  >
                                    <LuPencilLine /> Edit
                                  </button>
                                </div>
                                <ul className="rightliarrow">
                                  {resumeDetails?.skills &&
                                    resumeDetails?.skills?.map(
                                      (item: any, index: number) => {
                                        return (
                                          <div key={index}>
                                            <li>{item}</li>
                                          </div>
                                        );
                                      }
                                    )}
                                </ul>
                              </div>
                              <div className="flex-btn d-flex">
                                <Button
                                  className={`btn btn-primary ${
                                    isLoading ? "applied" : ""
                                  }`}
                                  onClick={prevHandler}
                                  // disabled={isLoading}
                                >
                                  Prev
                                </Button>
                                <Button
                                  className="btn btn-primary"
                                  onClick={nextHandler}
                                >
                                  {isLoading ? <ButtonLoader /> : "Save"}
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />
      <AddSkillModal show={showWork} onClose={handleCloseWK} isEdit={true} />
    </>
  );
};
export default ResumeAfteraddedQualificationInformationScreen;
